import classNames from 'classnames';
import type { Theme } from 'constants/colors';
import { useMemo } from 'react';
import { validateString } from 'utils/validate-string';

import styles from './component-block.module.scss';

interface Props {
  readonly theme?: Theme | undefined;
}

interface State {
  readonly rootClass: string;
}

// const accent100Class = validateString(styles.accent100);
// const accent50Class = validateString(styles.accent50);
// const primary100Class = validateString(styles.primary100);
const rootClass = validateString(styles.root);

export default function useComponentBlock({ theme }: Props): State {
  const themeClass: string | undefined = useMemo(() => {
    if (typeof theme === 'undefined') {
      return undefined;
    }

    return theme;
  }, [theme]);

  return {
    rootClass: classNames(rootClass, themeClass),
  };
}
